import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";


const Faqs = () => {

  const help = [
    { id: 1, title: 'FAQs', sub: 'Frequently asked questions and answers', button: 'Go to FAQs', link: ''},
    { id: 2, title: 'Guides', sub: 'Articles and resources to guide you', button: 'Check guides', link: ''},
    { id: 3, title: 'Support', sub: 'Contact us for more detailed support', button: 'Contact us', link: ''}
  ]


    return (
   <>


  <div className="mx-auto w-11/12 max-w-6xl m-10">

   <span className="sm:ml-3">
      <a href="/help-center" type="button" className="inline-flex items-center text-sm font-medium text-blue-700 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
      <svg xmlns="http://www.w3.org/2000/svg" className="-ml-1 mr-2 h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18"></path>
      </svg>
        Back to Help Center
      </a>
    </span>


   <div className="mt-2 text-3xl sm:text-5xl text-slate-800 font-extrabold dark:text-slate-200 leading-tight tracking-tight">Frequently Asked Questions</div>
   <div className="mt-2 text-xl text-inherit dark:text-slate-400">Here are the most frequently asked questions you may check before getting started</div>
  </div>



<div className="mx-auto w-11/12 max-w-6xl m-10  ">
<div className="mb-5 mt-12 sm:mt-16 text-3xl dark:text-gray-100 font-bold leading-tight tracking-tight">Most asked</div>
  <div id="accordion-collapse" data-accordion="collapse">
    <h2 id="accordion-collapse-heading-1">
      <button type="button" className="flex items-center justify-between w-full p-5 font-medium text-left text-gray-700 bg-white shadow rounded-t-xl focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800" data-accordion-target="#accordion-collapse-body-1" aria-expanded="true" aria-controls="accordion-collapse-body-1">
        <span>Is there a 14-days trial?</span>
        <svg data-accordion-icon className="w-6 h-6 rotate-180 shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
      </button>
    </h2>
    <div id="accordion-collapse-body-1" className="hidden" aria-labelledby="accordion-collapse-heading-1">
      <div className="p-5 font-light border border-b-0 border-gray-200 dark:border-gray-700 dark:bg-gray-900">
        <p className="mb-2 text-gray-500 dark:text-gray-400">Flowbite is an open-source library of interactive components built on top of Tailwind CSS including buttons, dropdowns, modals, navbars, and more.</p>
        <p className="text-gray-500 dark:text-gray-400">Check out this guide to learn how to <a href="/docs/getting-started/introduction/" className="text-blue-600 dark:text-blue-500 hover:underline">get started</a> and start developing websites even faster with components on top of Tailwind CSS.</p>
      </div>
    </div>
    <h2 id="accordion-collapse-heading-2">
      <button type="button" className="flex items-center justify-between w-full p-5 font-medium text-left text-gray-500 bg-white shadow focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800" data-accordion-target="#accordion-collapse-body-2" aria-expanded="false" aria-controls="accordion-collapse-body-2">
        <span>What’s the benefits of the Premium Membership?</span>
        <svg data-accordion-icon className="w-6 h-6 shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
      </button>
    </h2>
    <div id="accordion-collapse-body-2" className="hidden" aria-labelledby="accordion-collapse-heading-2">
      <div className="p-5 font-light border border-b-0 border-gray-200 dark:border-gray-700">
        <p className="mb-2 text-gray-500 dark:text-gray-400">Flowbite is first conceptualized and designed using the Figma software so everything you see in the library has a design equivalent in our Figma file.</p>
        <p className="text-gray-500 dark:text-gray-400">Check out the <a href="https://flowbite.com/figma/" className="text-blue-600 dark:text-blue-500 hover:underline">Figma design system</a> based on the utility classes from Tailwind CSS and components from Flowbite.</p>
      </div>
    </div>
    <h2 id="accordion-collapse-heading-3">
      <button type="button" className="flex items-center justify-between w-full p-5 font-medium text-left text-gray-500 bg-white shadow rounded-b-xl focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800" data-accordion-target="#accordion-collapse-body-3" aria-expanded="false" aria-controls="accordion-collapse-body-3">
        <span>Is there a month-to-month payment option?</span>
        <svg data-accordion-icon className="w-6 h-6 shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
      </button>
    </h2>
    <div id="accordion-collapse-body-3" className="hidden" aria-labelledby="accordion-collapse-heading-3">
      <div className="p-5 font-light border border-t-0 border-gray-200 dark:border-gray-700">
        <p className="mb-2 text-gray-500 dark:text-gray-400">The main difference is that the core components from Flowbite are open source under the MIT license, whereas Tailwind UI is a paid product. Another difference is that Flowbite relies on smaller and standalone components, whereas Tailwind UI offers sections of pages.</p>
        <p className="mb-2 text-gray-500 dark:text-gray-400">However, we actually recommend using both Flowbite, Flowbite Pro, and even Tailwind UI as there is no technical reason stopping you from using the best of two worlds.</p>
        <p className="mb-2 text-gray-500 dark:text-gray-400">Learn more about these technologies:</p>
        <ul className="pl-5 text-gray-500 list-disc dark:text-gray-400">
          <li><a href="https://flowbite.com/pro/" className="text-blue-600 dark:text-blue-500 hover:underline">Flowbite Pro</a></li>
          <li><a href="https://tailwindui.com/" rel="nofollow" className="text-blue-600 dark:text-blue-500 hover:underline">Tailwind UI</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div className="mx-auto w-11/12 max-w-6xl m-10 text-gray-700 dark:text-slate-200">
<div className="mb-5 mt-12 sm:mt-16 text-3xl font-bold leading-tight tracking-tight">General inquiries</div>
</div>

<div className="mx-auto w-11/12 max-w-6xl m-10 text-gray-700">
<div className="mb-5 mt-12 sm:mt-16 text-3xl dark:text-slate-200 font-bold leading-tight tracking-tight">Most asked</div>
    <h2 id="accordion-collapse-heading-3">
      <button type="button" className="flex items-center justify-between w-full p-5 font-medium text-left text-gray-500 bg-white shadow rounded-xl focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800" data-accordion-target="#accordion-collapse-body-3" aria-expanded="false" aria-controls="accordion-collapse-body-3">
        <span>Is there a month-to-month payment option?</span>
        <svg data-accordion-icon className="w-6 h-6 shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
      </button>
    </h2>
    <div id="accordion-collapse-body-3" className="hidden" aria-labelledby="accordion-collapse-heading-3">
      <div className="p-5 font-light border border-t-0 border-gray-200 dark:border-gray-700">
        <p className="mb-2 text-gray-500 dark:text-gray-400">The main difference is that the core components from Flowbite are open source under the MIT license, whereas Tailwind UI is a paid product. Another difference is that Flowbite relies on smaller and standalone components, whereas Tailwind UI offers sections of pages.</p>
        <p className="mb-2 text-gray-500 dark:text-gray-400">However, we actually recommend using both Flowbite, Flowbite Pro, and even Tailwind UI as there is no technical reason stopping you from using the best of two worlds.</p>
        <p className="mb-2 text-gray-500 dark:text-gray-400">Learn more about these technologies:</p>
        <ul className="pl-5 text-gray-500 list-disc dark:text-gray-400">
          <li><a href="https://flowbite.com/pro/" className="text-blue-600 dark:text-blue-500 hover:underline">Flowbite Pro</a></li>
          <li><a href="https://tailwindui.com/" rel="nofollow" className="text-blue-600 dark:text-blue-500 hover:underline">Tailwind UI</a></li>
        </ul>
      </div>
    </div>
</div>

<div className="mx-auto w-11/12 max-w-6xl m-10 text-gray-700 dark:text-slate-200">
<div className="mb-5 mt-12 sm:mt-16 text-3xl font-bold leading-tight tracking-tight">General inquiries</div>
</div>

<div className="mx-auto w-11/12 max-w-6xl m-10 text-gray-700 dark:text-slate-200">
<div className="mb-5 mt-12 sm:mt-16 text-3xl font-bold leading-tight tracking-tight">Licenses</div>
</div>

<div className="mx-auto w-11/12 max-w-6xl m-10 text-gray-700 dark:text-slate-200">
<div className="mb-5 mt-12 sm:mt-16 text-3xl font-bold leading-tight tracking-tight">Payments</div>
</div>

<div className="mx-auto w-11/12 max-w-6xl m-10 text-gray-700 dark:text-slate-200">
<div className="mb-5 mt-12 sm:mt-16 text-3xl font-bold leading-tight tracking-tight">Support</div>
</div>
   </>
    )
}

export default Faqs;
